// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.cart-page {
  background: var(--cart-bg);
  min-height: 100vh;
  color: var(--cart-color);
  display: flex;
  flex-direction: column;
  height: 100%;
}
.cart-page ion-content {
  --background: var(--cart-bg);
  height: 100%;
}
.cart-page ion-content::part(scroll) {
  overflow-y: auto;
}
.cart-page .cart-header ion-toolbar {
  --background: var(--bg-elevated);
  --color: var(--text-primary-dark);
}
.cart-page .cart-header ion-toolbar .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--page-padding);
  height: var(--header-height);
}
.cart-page .cart-header ion-toolbar .header-content .logo {
  font-size: var(--logo-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--logo-color);
}
.cart-page .cart-header ion-toolbar .header-content .menu-button {
  background: transparent;
  border: none;
  color: var(--menu-button-color);
  cursor: pointer;
  padding: var(--spacing-sm);
}
.cart-page .cart-header ion-toolbar .header-content .menu-button ion-icon {
  font-size: 24px;
}

.cart-container {
  padding: 0 var(--page-padding);
  max-width: 600px;
  margin: 0 auto;
}

.cart-title {
  padding: var(--spacing-xl) 0 var(--spacing-lg);
}
.cart-title h1 {
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
  margin: 0;
}

.empty-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}
.empty-cart .empty-cart-content .empty-icon {
  font-size: 64px;
  color: var(--text-secondary-light);
  margin-bottom: var(--spacing-lg);
}
.empty-cart .empty-cart-content h2 {
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
  margin-bottom: var(--spacing-md);
}
.empty-cart .empty-cart-content p {
  font-size: var(--font-size-body);
  color: var(--text-secondary-light);
  margin-bottom: var(--spacing-xl);
}
.empty-cart .empty-cart-content .add-items-btn {
  background: var(--button-primary);
  color: #ffffff;
  padding: var(--spacing-md) var(--spacing-xl);
  border-radius: var(--border-radius-pill);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
}

.cart-content {
  padding-bottom: var(--spacing-2xl);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.cart-items {
  margin-bottom: var(--spacing-xl);
}
.cart-items .cart-item {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-md);
  padding: var(--spacing-lg) 0;
  border-bottom: var(--cart-item-border);
}
.cart-items .cart-item:last-child {
  border-bottom: none;
}
.cart-items .cart-item .item-image {
  width: var(--product-image-size);
  height: var(--product-image-size);
  flex-shrink: 0;
  border-radius: var(--border-radius-md);
  overflow: hidden;
  background: #C4C4C4;
}
.cart-items .cart-item .item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.cart-items .cart-item .item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}
.cart-items .cart-item .item-content .item-header .item-name {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
  margin: 0;
}
.cart-items .cart-item .item-content .item-description {
  font-size: var(--font-size-body);
  color: var(--text-secondary-light);
  margin: 0;
  line-height: var(--line-height-normal);
}
.cart-items .cart-item .item-content .quantity-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  margin-top: var(--spacing-sm);
}
.cart-items .cart-item .item-content .quantity-controls .quantity-btn {
  width: var(--quantity-control-size);
  height: var(--quantity-control-size);
  border: var(--quantity-btn-border);
  background: transparent;
  color: var(--quantity-btn-color);
  border-radius: var(--border-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;
}
.cart-items .cart-item .item-content .quantity-controls .quantity-btn:hover:not(:disabled) {
  background: var(--quantity-btn-bg-hover);
  color: var(--quantity-btn-color-hover);
}
.cart-items .cart-item .item-content .quantity-controls .quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.cart-items .cart-item .item-content .quantity-controls .quantity-btn ion-icon {
  font-size: 16px;
}
.cart-items .cart-item .item-content .quantity-controls .quantity-display {
  min-width: 40px;
  text-align: center;
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
}
.cart-items .cart-item .remove-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-secondary-light);
  cursor: pointer;
  padding: var(--spacing-sm);
  border-radius: var(--border-radius-sm);
  transition: all 0.2s ease;
}
.cart-items .cart-item .remove-btn:hover {
  color: var(--error-color);
  background: rgba(220, 53, 69, 0.1);
}
.cart-items .cart-item .remove-btn ion-icon {
  font-size: 20px;
}

.add-more-btn {
  width: 100%;
  background: none;
  border: 2px solid var(--button-primary);
  color: var(--button-primary);
  padding: var(--spacing-md);
  border-radius: var(--border-radius-pill);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  cursor: pointer;
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
  margin-bottom: var(--spacing-xl);
  transition: all 0.2s ease;
}
.add-more-btn:hover {
  background: var(--button-primary);
  color: #ffffff;
}
.add-more-btn ion-icon {
  font-size: 20px;
}

.cart-summary {
  border-top: 2px solid #E5E5E5;
  padding-top: var(--spacing-xl);
}
.cart-summary .item-totals {
  margin-bottom: var(--spacing-lg);
}
.cart-summary .item-totals .item-total {
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-xs) 0;
  font-size: var(--font-size-caption);
  color: var(--text-secondary-light);
}
.cart-summary .grand-total {
  margin-bottom: var(--spacing-xl);
}
.cart-summary .grand-total .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-sm) 0;
}
.cart-summary .grand-total .total-row .total-label {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
}
.cart-summary .grand-total .total-row .total-price {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
}
.cart-summary .grand-total .total-row.final-total {
  border-top: 1px solid #E5E5E5;
  padding-top: var(--spacing-md);
  margin-top: var(--spacing-sm);
}
.cart-summary .grand-total .total-row.final-total .total-label,
.cart-summary .grand-total .total-row.final-total .total-price {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-bold);
}
.cart-summary .continue-btn {
  width: 100%;
  background: var(--button-primary);
  color: #ffffff;
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-pill);
  font-size: var(--font-size-button-large);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.cart-summary .continue-btn:hover:not(:disabled) {
  background: var(--vendomat-blue-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-button-hover);
}
.cart-summary .continue-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .cart-container {
    padding: 0 var(--spacing-md);
  }
  .cart-item {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-md);
  }
  .cart-item .item-image {
    align-self: center;
  }
  .cart-item .item-content {
    width: 100%;
  }
  .cart-item .remove-btn {
    align-self: flex-end;
    position: absolute;
    right: var(--spacing-md);
  }
}
@media (max-width: 480px) {
  .cart-title h1 {
    font-size: var(--font-size-h2);
  }
  .item-content .item-name {
    font-size: var(--font-size-body);
  }
  .quantity-controls .quantity-btn {
    width: 32px;
    height: 32px;
  }
}
@keyframes itemFadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-20px);
  }
}
.cart-item.removing {
  animation: itemFadeOut 0.3s ease-out forwards;
}

.cart-item.loading {
  opacity: 0.6;
  pointer-events: none;
}

.quantity-btn:focus,
.remove-btn:focus,
.continue-btn:focus,
.add-more-btn:focus {
  outline: 2px solid var(--vendomat-blue-light);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shopping-cart/shopping-cart.component.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,0BAAA;EACA,iBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAFF;AAKE;EACE,4BAAA;EACA,YAAA;AAHJ;AAKI;EACE,gBAAA;AAHN;AASI;EACE,gCAAA;EACA,iCAAA;AAPN;AASM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,4BAAA;AAPR;AASQ;EACE,gCAAA;EACA,uCAAA;EACA,wBAAA;AAPV;AAUQ;EACE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,0BAAA;AARV;AAUU;EACE,eAAA;AARZ;;AAgBA;EACE,8BAAA;EACA,gBAAA;EACA,cAAA;AAbF;;AAiBA;EACE,8CAAA;AAdF;AAgBE;EACE,8BAAA;EACA,wCAAA;EACA,gCAAA;EACA,SAAA;AAdJ;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;AAmBI;EACE,eAAA;EACA,kCAAA;EACA,gCAAA;AAjBN;AAoBI;EACE,8BAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;AAlBN;AAqBI;EACE,gCAAA;EACA,kCAAA;EACA,gCAAA;AAnBN;AAsBI;EACE,iCAAA;EACA,cAAA;EACA,4CAAA;EACA,wCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;EACA,sCAAA;AApBN;;AA0BA;EACE,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAvBF;;AA2BA;EACE,gCAAA;AAxBF;AA2BE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sCAAA;AAzBJ;AA2BI;EACE,mBAAA;AAzBN;AA6BI;EACE,gCAAA;EACA,iCAAA;EACA,cAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;AA3BN;AA6BM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3BR;AAgCI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AA9BN;AAiCQ;EACE,8BAAA;EACA,wCAAA;EACA,gCAAA;EACA,SAAA;AA/BV;AAmCM;EACE,gCAAA;EACA,kCAAA;EACA,SAAA;EACA,sCAAA;AAjCR;AAqCM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;AAnCR;AAqCQ;EACE,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,uBAAA;EACA,gCAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAnCV;AAqCU;EACE,wCAAA;EACA,sCAAA;AAnCZ;AAsCU;EACE,YAAA;EACA,mBAAA;AApCZ;AAuCU;EACE,eAAA;AArCZ;AAyCQ;EACE,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,sCAAA;EACA,gCAAA;AAvCV;AA6CI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,eAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;AA3CN;AA6CM;EACE,yBAAA;EACA,kCAAA;AA3CR;AA8CM;EACE,eAAA;AA5CR;;AAmDA;EACE,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,0BAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,kCAAA;EACA,sCAAA;EACA,gCAAA;EACA,yBAAA;AAhDF;AAkDE;EACE,iCAAA;EACA,cAAA;AAhDJ;AAmDE;EACE,eAAA;AAjDJ;;AAsDA;EACE,6BAAA;EACA,8BAAA;AAnDF;AAsDE;EACE,gCAAA;AApDJ;AAsDI;EACE,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,mCAAA;EACA,kCAAA;AApDN;AAyDE;EACE,gCAAA;AAvDJ;AAyDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAvDN;AAyDM;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;AAvDR;AA0DM;EACE,gCAAA;EACA,wCAAA;EACA,gCAAA;AAxDR;AA2DM;EACE,6BAAA;EACA,8BAAA;EACA,6BAAA;AAzDR;AA2DQ;;EAEE,8BAAA;EACA,oCAAA;AAzDV;AAgEE;EACE,WAAA;EACA,iCAAA;EACA,cAAA;EACA,0BAAA;EACA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AA9DJ;AAgEI;EACE,qCAAA;EACA,2BAAA;EACA,sCAAA;AA9DN;AAiEI;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/DN;;AAqEA;EACE;IACE,4BAAA;EAlEF;EAqEA;IACE,sBAAA;IACA,uBAAA;IACA,sBAAA;EAnEF;EAqEE;IACE,kBAAA;EAnEJ;EAsEE;IACE,WAAA;EApEJ;EAuEE;IACE,oBAAA;IACA,kBAAA;IACA,wBAAA;EArEJ;AACF;AAyEA;EACE;IACE,8BAAA;EAvEF;EA0EA;IACE,gCAAA;EAxEF;EA4EE;IACE,WAAA;IACA,YAAA;EA1EJ;AACF;AA+EA;EACE;IACE,UAAA;IACA,wBAAA;EA7EF;EA+EA;IACE,UAAA;IACA,4BAAA;EA7EF;AACF;AAgFA;EACE,6CAAA;AA9EF;;AAkFA;EACE,YAAA;EACA,oBAAA;AA/EF;;AAmFA;;;;EAIE,6CAAA;EACA,mBAAA;AAhFF","sourcesContent":["// Shopping Cart Component Styles\n// Based on \"Dein Warenkorb\" design from screenshots\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.cart-page {\n  background: var(--cart-bg);\n  min-height: 100vh;\n  color: var(--cart-color);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  // Make ion-content scrollable\n  ion-content {\n    --background: var(--cart-bg);\n    height: 100%;\n\n    &::part(scroll) {\n      overflow-y: auto;\n    }\n  }\n\n  // Header styling\n  .cart-header {\n    ion-toolbar {\n      --background: var(--bg-elevated);\n      --color: var(--text-primary-dark);\n\n      .header-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: var(--spacing-md) var(--page-padding);\n        height: var(--header-height);\n\n        .logo {\n          font-size: var(--logo-font-size);\n          font-weight: var(--font-weight-regular);\n          color: var(--logo-color);\n        }\n\n        .menu-button {\n          background: transparent;\n          border: none;\n          color: var(--menu-button-color);\n          cursor: pointer;\n          padding: var(--spacing-sm);\n\n          ion-icon {\n            font-size: 24px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.cart-container {\n  padding: 0 var(--page-padding);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n// Cart Title\n.cart-title {\n  padding: var(--spacing-xl) 0 var(--spacing-lg);\n\n  h1 {\n    font-size: var(--font-size-h1);\n    font-weight: var(--font-weight-semibold);\n    color: var(--text-primary-light);\n    margin: 0;\n  }\n}\n\n// Empty Cart State\n.empty-cart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n\n  .empty-cart-content {\n    .empty-icon {\n      font-size: 64px;\n      color: var(--text-secondary-light);\n      margin-bottom: var(--spacing-lg);\n    }\n\n    h2 {\n      font-size: var(--font-size-h2);\n      font-weight: var(--font-weight-medium);\n      color: var(--text-primary-light);\n      margin-bottom: var(--spacing-md);\n    }\n\n    p {\n      font-size: var(--font-size-body);\n      color: var(--text-secondary-light);\n      margin-bottom: var(--spacing-xl);\n    }\n\n    .add-items-btn {\n      background: var(--button-primary);\n      color: #ffffff;\n      padding: var(--spacing-md) var(--spacing-xl);\n      border-radius: var(--border-radius-pill);\n      border: none;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: var(--spacing-sm);\n      font-size: var(--font-size-button);\n      font-weight: var(--font-weight-medium);\n    }\n  }\n}\n\n// Cart Content\n.cart-content {\n  padding-bottom: var(--spacing-2xl);\n  display: flex;\n  flex-direction: column;\n  min-height: 0; // Important for flexbox scrolling\n}\n\n// Cart Items\n.cart-items {\n  margin-bottom: var(--spacing-xl);\n  // Let ion-content handle scrolling\n\n  .cart-item {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--spacing-md);\n    padding: var(--spacing-lg) 0;\n    border-bottom: var(--cart-item-border);\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    // Product Image\n    .item-image {\n      width: var(--product-image-size);\n      height: var(--product-image-size);\n      flex-shrink: 0;\n      border-radius: var(--border-radius-md);\n      overflow: hidden;\n      background: #C4C4C4;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    // Item Content\n    .item-content {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: var(--spacing-sm);\n\n      .item-header {\n        .item-name {\n          font-size: var(--font-size-h3);\n          font-weight: var(--font-weight-semibold);\n          color: var(--text-primary-light);\n          margin: 0;\n        }\n      }\n\n      .item-description {\n        font-size: var(--font-size-body);\n        color: var(--text-secondary-light);\n        margin: 0;\n        line-height: var(--line-height-normal);\n      }\n\n      // Quantity Controls\n      .quantity-controls {\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-md);\n        margin-top: var(--spacing-sm);\n\n        .quantity-btn {\n          width: var(--quantity-control-size);\n          height: var(--quantity-control-size);\n          border: var(--quantity-btn-border);\n          background: transparent;\n          color: var(--quantity-btn-color);\n          border-radius: var(--border-radius-sm);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          font-size: 18px;\n          transition: all 0.2s ease;\n\n          &:hover:not(:disabled) {\n            background: var(--quantity-btn-bg-hover);\n            color: var(--quantity-btn-color-hover);\n          }\n\n          &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n          }\n\n          ion-icon {\n            font-size: 16px;\n          }\n        }\n\n        .quantity-display {\n          min-width: 40px;\n          text-align: center;\n          font-size: var(--font-size-body);\n          font-weight: var(--font-weight-medium);\n          color: var(--text-primary-light);\n        }\n      }\n    }\n\n    // Remove Button\n    .remove-btn {\n      background: none;\n      border: none;\n      font-size: 24px;\n      color: var(--text-secondary-light);\n      cursor: pointer;\n      padding: var(--spacing-sm);\n      border-radius: var(--border-radius-sm);\n      transition: all 0.2s ease;\n\n      &:hover {\n        color: var(--error-color);\n        background: rgba(220, 53, 69, 0.1);\n      }\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n}\n\n// Add More Items Button\n.add-more-btn {\n  width: 100%;\n  background: none;\n  border: 2px solid var(--button-primary);\n  color: var(--button-primary);\n  padding: var(--spacing-md);\n  border-radius: var(--border-radius-pill);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  cursor: pointer;\n  font-size: var(--font-size-button);\n  font-weight: var(--font-weight-medium);\n  margin-bottom: var(--spacing-xl);\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: var(--button-primary);\n    color: #ffffff;\n  }\n\n  ion-icon {\n    font-size: 20px;\n  }\n}\n\n// Cart Summary\n.cart-summary {\n  border-top: 2px solid #E5E5E5;\n  padding-top: var(--spacing-xl);\n\n  // Individual item totals (if needed)\n  .item-totals {\n    margin-bottom: var(--spacing-lg);\n\n    .item-total {\n      display: flex;\n      justify-content: space-between;\n      padding: var(--spacing-xs) 0;\n      font-size: var(--font-size-caption);\n      color: var(--text-secondary-light);\n    }\n  }\n\n  // Grand total section\n  .grand-total {\n    margin-bottom: var(--spacing-xl);\n\n    .total-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: var(--spacing-sm) 0;\n\n      .total-label {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-medium);\n        color: var(--text-primary-light);\n      }\n\n      .total-price {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-semibold);\n        color: var(--text-primary-light);\n      }\n\n      &.final-total {\n        border-top: 1px solid #E5E5E5;\n        padding-top: var(--spacing-md);\n        margin-top: var(--spacing-sm);\n\n        .total-label,\n        .total-price {\n          font-size: var(--font-size-h3);\n          font-weight: var(--font-weight-bold);\n        }\n      }\n    }\n  }\n\n  // Continue Button\n  .continue-btn {\n    width: 100%;\n    background: var(--button-primary);\n    color: #ffffff;\n    padding: var(--spacing-lg);\n    border-radius: var(--border-radius-pill);\n    font-size: var(--font-size-button-large);\n    font-weight: var(--font-weight-medium);\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n\n    &:hover:not(:disabled) {\n      background: var(--vendomat-blue-dark);\n      transform: translateY(-1px);\n      box-shadow: var(--shadow-button-hover);\n    }\n\n    &:disabled {\n      background: #cccccc;\n      cursor: not-allowed;\n      transform: none;\n      box-shadow: none;\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .cart-container {\n    padding: 0 var(--spacing-md);\n  }\n\n  .cart-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-md);\n\n    .item-image {\n      align-self: center;\n    }\n\n    .item-content {\n      width: 100%;\n    }\n\n    .remove-btn {\n      align-self: flex-end;\n      position: absolute;\n      right: var(--spacing-md);\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .cart-title h1 {\n    font-size: var(--font-size-h2);\n  }\n\n  .item-content .item-name {\n    font-size: var(--font-size-body);\n  }\n\n  .quantity-controls {\n    .quantity-btn {\n      width: 32px;\n      height: 32px;\n    }\n  }\n}\n\n// Animation for item removal\n@keyframes itemFadeOut {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n}\n\n.cart-item.removing {\n  animation: itemFadeOut 0.3s ease-out forwards;\n}\n\n// Loading states\n.cart-item.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n// Focus management\n.quantity-btn:focus,\n.remove-btn:focus,\n.continue-btn:focus,\n.add-more-btn:focus {\n  outline: 2px solid var(--vendomat-blue-light);\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
